import React, { memo } from 'react'
import { BW_COLOR_SUCCESS } from 'src/libs/qb-brand-web-components'
import { faCheckCircle } from '@fortawesome/pro-duotone-svg-icons'
import { Trans } from 'react-i18next'

import customConfig from 'customConfig'
import ReceivePoints from '../common/ReceivePoints'
import { formatTicks } from '../../../util/string.helpers'
import Text from '../../text/Text'
import AnimateRewards from '../../shared/animateRewards/AnimateRewards'

const ReceivePointsSuccess = ({
  t,
  onCancel,
  reward,
  tokenProfile,
  ...restProps
}) => {
  const isFutureReward = reward?.campaign?.deltaSeconds
  const exchangePointsLabel = !isFutureReward
  return (
    <ReceivePoints
      title={
        isFutureReward
          ? t('reward.future-points')
          : t(customConfig.youEarnedItTitle)
      }
      description={
        isFutureReward ? (
          <Trans
            i18nKey='reward.future-reward-success'
            values={{
              value: formatTicks(reward?.value),
              name: tokenProfile.name
            }}
          />
        ) : (
          t(customConfig.receivedPointsDesc)
        )
      }
      color={BW_COLOR_SUCCESS}
      cancelLabel={exchangePointsLabel && 'common.close'}
      onCancel={exchangePointsLabel && onCancel}
      submitLabel={
        !customConfig?.disableCodeToPointsAction &&
        t(
          exchangePointsLabel
            ? 'exchange.exchange-points-now'
            : customConfig.receivedPointsButtonLabel
        )
      }
      t={t}
      value={!isFutureReward && reward.value}
      icon={faCheckCircle}
      additionalDesc={
        isFutureReward && <Text label={t('reward.future-reward-desc-points')} />
      }
      {...tokenProfile}
      {...restProps}
    >
      <AnimateRewards />
    </ReceivePoints>
  )
}

export default memo(ReceivePointsSuccess)
